import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useAllowFeature } from "@hooks/useAllowFeature";
import { resolveBuiltInSchedulesReportView } from "./schedulesReportDeepLink";
import { SchedulesReportPage } from "./SchedulesReportPage";
import { SchedulesReportPaywalled } from "./SchedulesReportPaywalled";
import { useSchedulesReportParams } from "./useSchedulesReportParams";

export const SchedulesReportPageWrapper = () => {
    const { hasAccess, isFetched } = useAllowFeature(
        PREMIUM_FEATURES.SCHEDULES,
    );
    const { params, viewId } = useSchedulesReportParams();

    if (!isFetched) {
        return null;
    }

    if (!hasAccess) {
        const layout =
            resolveBuiltInSchedulesReportView(viewId)?.filters.scheduleLayout ??
            params.layout;
        return <SchedulesReportPaywalled layout={layout} />;
    }

    return <SchedulesReportPage />;
};
